import { makeStyles } from 'tss-react/mui';

const name = 'ProjectsSkeleton';

export const useProjectsSkeletonStyles = makeStyles({ name })(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
}));
